import * as React from 'react';
import { Spinner, SpinnerSize } from '@fluentui/react';
import { max } from 'lodash-es';
import '../dashboard/CustomFilter.css';
import { v1 as uniqueID } from 'uuid';
import { FontIcon } from '@fluentui/react';
import { connect } from 'react-redux';
import { GetFields } from '../Common/Models/DropdownConstants';
import { UATConstants } from 'src/Common/Models/UATConstants';
import AnalyticsFilterItem from './AnalyticsFilterItem';
import { AnalyticsField, AnalyticsFieldFilter, FieldFilter } from './AnalyticsModel';

export interface CustomFilterItemListState {
  //isGrouped: boolean;
  customQuery: AnalyticsFieldFilter;
  isUpdate: boolean;
  fieldOptions: any[];
  field: AnalyticsField[];
  showSpinner: boolean;
}

export interface CustomFilterItemListProps {
  customQuery: AnalyticsFieldFilter;
  isEdit: boolean;
  updateCustomQueryData: Function;
  onDelete: Function;
  fieldsList: AnalyticsFieldFilter;
  avFields: AnalyticsField[];
  tagsOptions: any[];
  assignedTeam: any[];
}

class AnalyticsFilterList extends React.Component<
  CustomFilterItemListProps,
  CustomFilterItemListState
> {
  constructor(props: CustomFilterItemListProps) {
    super(props);

    this.state = {
      customQuery: props.fieldsList ? props.fieldsList : this.generateNewQuery(),
      isUpdate: props.isEdit,
      fieldOptions: [],
      field: [],
      showSpinner: false,
    };
  }

  componentDidMount() {
    this.initFields(this.props.avFields);
  }

  private initFields = (allAVFields: AnalyticsField[]) => {
    this.setFields(allAVFields);
  };

  private setFields = (fields: AnalyticsField[]) => {
    const options: any[] = [];
    const adoFields = GetFields();

    //Form Field Type matching to existing ADO fields
    fields.forEach((item: any) => {
      //Skip the disallowFiltering: false
      if (item.disallowFiltering === false) {
        item.isDate = item.type === 'Edm.DateTimeOffset' ? true : false;
        item.isIdentity =
          item.type === 'Microsoft.VisualStudio.Services.Analytics.Model.User' ? true : false;
        item.isNumber = item.type === 'Edm.Int32' ? true : false;
        item.isDecimal = item.type === 'Edm.Int64' ? true : false;
        item.isBoolean = item.type === 'Edm.Boolean' ? true : false;
        item.isPicklist = false;
        if (item.type === 'Edm.String') {
          let selectedFieldText = item.propertyName;
          if (selectedFieldText.startsWith('Custom_'))
            selectedFieldText = selectedFieldText.replace('Custom_', 'Custom.');
          else selectedFieldText = 'System.' + selectedFieldText;

          //This method is still missing the few fields like activity and application etc
          if (UATConstants.PickListFields.includes(selectedFieldText)) {
            item.isPicklist = true;
          } else {
            const a = adoFields && adoFields.find((item) => item.ReferenceName === selectedFieldText);
            if (a) {
              item.isPicklist = a?.IsPicklist;
            }
          }
        }

        item.isMultiSelect = false;

        //Special Fields comparision
        if (item.propertyName === 'TagNames') {
          item.isTags = true;
          item.isPicklist = false;
        } else {
          item.isTags = false;
        }

        if (
          item.propertyName === 'Area/AreaPath' ||
          item.propertyName === 'Iteration/IterationPath'
        ) {
          item.isAreaPathOrIteration = true;
        } else item.isAreaPathOrIteration = false;

        options.push({
          type: item.type,
          key: item.propertyName,
          text: item.displayName,
          referenceName: item.propertyName,
          isDate: item.isDate,
          isIdentity: item.isIdentity,
          isNumber: item.isNumber,
          isBoolean: item.isBoolean,
          isPicklist: item.isPicklist,
          isMultiSelect: item.isMultiSelect,
          isAreaPathOrIteration: item.isAreaPathOrIteration,
          isTags: item.isTags,
          isDecimal: item.isDecimal,
        });
      }
    });

    options.sort((a, b) => (a.text > b.text ? 1 : -1));
    this.setState({
      fieldOptions: options,
      field: fields,
    });
  };

  generateNewQuery = (): AnalyticsFieldFilter => {
    const clauseNew: FieldFilter = {
      id: uniqueID(),
      index: 0,
      fieldName: '',
      fieldOperation: 0,
      value: {
        mode: 0,
        operator: 0,
        values: [''],
      },
      fieldValue: null,
      fieldValuesOperator: 0,
      fieldDisplayName: '',
      unknownPropertyDisplayName: null,
      fieldErrorMessage: null,
      valueErrorMessage: null,
      unknownValueText: null,
    };
    const query = new AnalyticsFieldFilter();
    query.fieldFilters.push(clauseNew);
    return query;
  };

  private addNewClause = () => {
    const itemIndex = (max(this.state.customQuery.fieldFilters.map((g) => g.index)) || 0) + 1;
    const id = uniqueID();
    const clauseNew: FieldFilter = {
      id: uniqueID(),
      index: itemIndex,
      fieldName: '',
      fieldOperation: 0,
      value: {
        mode: 0,
        operator: 0,
        values: [''],
      },
      fieldValue: null,
      fieldValuesOperator: 0,
      fieldDisplayName: '',
      unknownPropertyDisplayName: null,
      fieldErrorMessage: null,
      valueErrorMessage: null,
      unknownValueText: null,
    };

    const clauses = this.state.customQuery.fieldFilters;
    clauses.push(clauseNew);

    this.setState({
      customQuery: {
        ...this.state.customQuery,
        fieldFilters: clauses,
      },
    });
  };

  onDelete = (id: string) => {
    const queryGroups = this.updateQueryGroupIndex(id);
    this.setState(
      {
        customQuery: {
          ...this.state.customQuery,
          fieldFilters: queryGroups,
        },
      },
      () => {
        this.props.updateCustomQueryData(this.state.customQuery);
      }
    );
  };

  updateQueryGroupIndex = (id: string): FieldFilter[] => {
    const queryGroups = [...this.state.customQuery.fieldFilters];
    const grpIndex = queryGroups.findIndex((g) => g.id === id);
    if (grpIndex > -1) {
      queryGroups.splice(grpIndex, 1);
    }
    queryGroups.forEach((grp) => {
      if (grp.index > grpIndex) {
        grp.index -= 1;
      }
    });
    return queryGroups;
  };

  updateList = (queryGroup: FieldFilter) => {
    let queryGroups = [...this.state.customQuery.fieldFilters];
    const filterdItems = queryGroups.filter((g) => g.id === queryGroup.id);
    const index = queryGroups.findIndex((f: FieldFilter) => queryGroup.id === f.id);
    queryGroups = [...queryGroups.slice(0, index), queryGroup, ...queryGroups.slice(index + 1)];
    if (filterdItems.length > 0) {
      this.setState(
        {
          customQuery: {
            ...this.state.customQuery,
            fieldFilters: queryGroups,
          },
        },
        () => this.props.updateCustomQueryData(this.state.customQuery)
      );
    }
  };

  render() {
    return (
      <div className='customFilterContainer'>
        <div>
          {this.state.showSpinner && (
            <Spinner
              size={SpinnerSize.large}
              label={UATConstants.PlaceholdersAndTitles.Loading}
              ariaLive='assertive'
              className='loading-panel-full'
            />
          )}
        </div>

        <div className='ms-Grid query-filter source-filter'>
          <table className='clauses'>
            <tbody>
              <tr className='header'>
                <th className='av-field ms-Grid-col'>
                  Field{' '}
                  <span tabIndex={0} className='colorRed'>
                    *
                  </span>
                </th>
                <th className='operator'>Operator</th>
                <th className='value ms-Grid-col'>Value</th>
                <th className='add-remove'></th>
              </tr>
              {this.state.fieldOptions.length > 0 &&
                this.props.assignedTeam.length > 0 &&
                this.state.customQuery.fieldFilters.map((value, index) => {
                  return (
                    <AnalyticsFilterItem
                      key={value.id.toString()}
                      fieldOptions={this.state.fieldOptions}
                      queryItem={value}
                      queryItemIndex={index}
                      updateParentList={this.updateList}
                      onDelete={this.onDelete}
                      assignedTeam={this.props.assignedTeam}
                      tagsOptions={this.props.tagsOptions}
                    />
                  );
                })}
            </tbody>
          </table>
          <div className='ms-Grid-row'>
            <div
              className='ms-Grid-col ms-lg4'
              title={UATConstants.PlaceholdersAndTitles.AddNewCriteria}>
              <a className='av-showMenu' onClick={this.addNewClause}>
                <FontIcon
                  iconName={UATConstants.PlaceholdersAndTitles.AddTo}
                  className='caFIcons caFIconPlus menuFIcon'
                />
                <span className='outlineNone padding-left5' tabIndex={0}>
                  {UATConstants.PlaceholdersAndTitles.AddNewCriteria}
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: any, ownProps: any) => ({
  ...state,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(AnalyticsFilterList);
